const nf = new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const tl = (v) => `${nf.format(Number(v || 0))} ₺`;
export const dt = (iso) => (iso ? new Date(iso).toLocaleString("tr-TR", { dateStyle: "medium", timeStyle: "short" }) : "-");
export const d = (iso) => (iso ? new Date(iso).toLocaleDateString("tr-TR") : "-");
export const phoneFmt = (p) => {
  const s = String(p || "").replace(/\D/g, "").slice(-10);
  return s.length === 10 ? `0${s.slice(0, 3)} ${s.slice(3, 6)} ${s.slice(6, 8)} ${s.slice(8)}` : p;
};
export const grams = (g) => (g >= 1000 ? `${(g / 1000).toLocaleString("tr-TR")} kg` : `${g} g`);

export const STATUS = {
  odeme_bekleniyor: { label: "Ödeme Bekleniyor", cls: "bg-amber-500/15 text-amber-500 border-amber-500/30" },
  hazirlaniyor: { label: "Hazırlanıyor", cls: "bg-sky-500/15 text-sky-400 border-sky-500/30" },
  kargoya_verildi: { label: "Kargoya Verildi", cls: "bg-violet-500/15 text-violet-400 border-violet-500/30" },
  dagitimda: { label: "Dağıtımda", cls: "bg-orange-500/15 text-orange-400 border-orange-500/30" },
  teslim_edildi: { label: "Teslim Edildi", cls: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30" },
  iptal: { label: "İptal Edildi", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
  iade: { label: "İade Edildi", cls: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30" },
};
export const PAYMENT = { kart: "Kredi / Banka Kartı", havale: "Havale / EFT" };

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || { label: status, cls: "" };
  return (
    <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls}`}>
      {s.label}
    </span>
  );
};
